import React, { useState, useEffect } from "react";
import Content from "../layout/content/Content";
import Head from "../layout/head/Head";
import { Card, Spinner, Alert } from "reactstrap";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BackTo,
  Icon,
  Button,
  Row,
  Col,
  PreviewAltCard,
} from "../components/Component";
import { Empty } from "antd";
import { baseURLs } from "../utils/Constants";
import { getAxiosHeaders } from "../utils/Utils";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./components/expense/Header";
import Body from "./components/expense/Body";

const ExpenseDetails = ({ history, match }) => {
  const [sm, updateSm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [businessID, setBusinessID] = useState("");
  const [businessInfo, setBusinessInfo] = useState({});
  const [expenseDetails, setExpenseDetails] = useState({
    business_id: "",
    currency: "",
    expense_id: "",
    expense_title: "",
    issue_date: "",
    has_supplier: "no",
    supplier_info: {
      supplier_name: "",
      phone_number: "",
      email: "",
      other_info: "",
    },
    items: [],
    status: "",
    expense_type: "",
    fulfillment_status: "",
    has_approval: "no",
    approve_by: {
      full_name: "",
      email: "",
      uuid: "",
    },
    sub_total_amount: "",
    discount_amount: "",
    tax_amount: "",
    total_amount: "",
    amount_paid: "",
    balance_due: "",
    attachment_url: null,
    payment_log: [],
    note: "",
    recorded_by: "",
    created_at: "",
    user_info: {
      full_name: "",
      email: "",
    },
  });
  const [errorMessage, setErrorMessage] = useState("");

  const getExpenseDetails = (businessInfo, expenseID) => {
    setLoading(true);
    axios
      .get(baseURLs.API_URL + `/expenses/${expenseID}`, {
        params: {
          business_id: businessInfo.business_id,
        },
        headers: getAxiosHeaders().headers,
      })
      .then((response) => {
        if (response.status === 204) {
          setErrorMessage("Expense not found");
        } else {
          let responseInfo = response.data;
          let expenseInfo = responseInfo.data.expense_info;
          let _expenseDetails = expenseDetails;

          _expenseDetails.business_id = businessInfo.business_id;
          _expenseDetails.currency = businessInfo.currency;
          _expenseDetails.user_info = businessInfo.user_info;

          _expenseDetails.expense_id = expenseID;
          _expenseDetails.expense_title = expenseInfo.expense_title;
          _expenseDetails.issue_date = expenseInfo.issue_date;
          _expenseDetails.has_supplier = expenseInfo.has_supplier;
          _expenseDetails.supplier_info = expenseInfo.supplier_info;
          _expenseDetails.approve_by = expenseInfo.approve_by;
          _expenseDetails.has_approval = expenseInfo.has_approval;
          _expenseDetails.expense_type = expenseInfo.expense_type;
          _expenseDetails.fulfillment_status = expenseInfo.fulfillment_status;
          _expenseDetails.items = expenseInfo.items;
          _expenseDetails.status = expenseInfo.status;
          _expenseDetails.sub_total_amount = expenseInfo.sub_total_amount;
          _expenseDetails.discount_amount = expenseInfo.discount_amount;
          _expenseDetails.tax_amount = expenseInfo.tax_amount;
          _expenseDetails.total_amount = expenseInfo.total_amount;
          _expenseDetails.amount_paid = expenseInfo.amount_paid;
          _expenseDetails.balance_due = expenseInfo.balance_due;
          _expenseDetails.attachment_url = expenseInfo.attachment_url;
          _expenseDetails.note = expenseInfo.note;
          _expenseDetails.recorded_by = expenseInfo.recorded_by;
          _expenseDetails.payment_log =
            expenseInfo.payment_log.length > 1
              ? expenseInfo.payment_log.reverse()
              : expenseInfo.payment_log;
          _expenseDetails.created_at = expenseInfo.created_at;

          setExpenseDetails({ ..._expenseDetails });
        }
        setLoading(false);
      })
      .catch((error) => {
        try {
          let errorResponse = error.response.data;

          let errorMessage = "Error: Could not connect to server";
          if (errorResponse.hasOwnProperty("error")) {
            errorMessage = errorResponse.error;
          }

          setErrorMessage(errorMessage);
          setLoading(false);
        } catch (e) {
          console.log(e);
          // history.push(`${process.env.PUBLIC_URL}/server-offline`);
        }
      });
  };

  useEffect(() => {
    setLoading(true);
    const _businessID = parseInt(match.params.businessID, 10);
    const expenseID = match.params.expenseID;
    if (Number.isInteger(_businessID) && expenseID) {
      localStorage.setItem("current_business_id", _businessID);
      let businesses = JSON.parse(localStorage.getItem("my_businesses"));
      let currentBusiness = businesses?.find(
        (business) => business.business_id == _businessID
      );

      if (currentBusiness == undefined || null || "") {
        history.push(`${process.env.PUBLIC_URL}/not-found`);
        return;
      }

      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      currentBusiness = {
        ...currentBusiness,
        user_info: {
          full_name: userInfo.full_name,
          email: userInfo.email,
        },
      };
      setBusinessInfo({ ...currentBusiness });
      setBusinessID(_businessID);
      getExpenseDetails(currentBusiness, expenseID);
    } else {
      history.push(`${process.env.PUBLIC_URL}/not-found`);
      return;
    }
  }, [match.params.business]);

  return (
    <React.Fragment>
      <Head title="Expense Details" />
      <Content>
        {loading ? (
          <Block className="nk-block-middle nk-auth-body text-center wide-xs">
            <div className="inner-pre-loader">
              <Spinner color="dark" />
            </div>
          </Block>
        ) : (
          <>
            <BlockHead className="mb-4" size="sm">
              <div className="nk-block-between">
                <BlockHeadContent>
                  <BlockDes className="text-soft">
                    <p>{businessInfo.name}</p>
                  </BlockDes>
                  <BlockTitle page tag="h3">
                    <span>Expense Details</span>
                  </BlockTitle>
                </BlockHeadContent>
                <BlockHeadContent>
                  <div className="toggle-wrap nk-block-tools-toggle">
                    <Button
                      className={`btn-icon btn-trigger toggle-expand me-n1 ${
                        sm ? "active" : ""
                      }`}
                      onClick={() => updateSm(!sm)}
                    >
                      <Icon name="more-v"></Icon>
                    </Button>
                    <div
                      className="toggle-expand-content"
                      style={{ display: sm ? "block" : "none" }}
                    >
                      <ul className="nk-block-tools g-3">
                        <li>
                          <BackTo
                            className="mb-3"
                            history={history}
                            link={`/expenses/b/${businessID}`}
                            icon="arrow-left"
                            type="button"
                          >
                            Go Back
                          </BackTo>
                        </li>
                      </ul>
                    </div>
                  </div>
                </BlockHeadContent>
              </div>
            </BlockHead>
            <Block className="wide-sm m-auto">
              {errorMessage ? (
                <Card className="card-bordered">
                  <div className="card-inner">
                    <div className="text-center m-5">
                      <div className="price-plan-media">
                        <Empty
                          image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                          imageStyle={{ height: 60 }}
                          description={false}
                        />
                      </div>
                      <div className="price-plan-info">
                        <h5 className="title fw-normal">Expenses not found</h5>
                        <span>
                          The expenses you are looking for could not be found.
                        </span>
                        <p className="text-soft">
                          If you need help, you can reach us on our{" "}
                          <a href={baseURLs.LIVE_CHAT}>live chat</a>.
                        </p>
                      </div>
                      <div className="price-plan-action">
                        <Link
                          to={`${process.env.PUBLIC_URL}/expenses/b/${businessID}`}
                        >
                          <button className="btn btn-outline-primary">
                            Go to Expenses
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </Card>
              ) : (
                <Card className="card-bordered">
                  <Header headerInfo={expenseDetails} />
                  <Body
                    history={history}
                    expenseInfo={expenseDetails}
                    setExpenseInfo={setExpenseDetails}
                  />
                </Card>
              )}
            </Block>
          </>
        )}
      </Content>
    </React.Fragment>
  );
};

export default ExpenseDetails;
